<template>
  <TemplateEdit v-loading="editLoading" :get-data="getData" :edit-title="editTitle" ref="edit" class="news-edit-container">
      <el-form label-width="100px" size="small" :rules="rules" :model="editData" ref="editForm" class="bg-white p-3">
        <el-row type="flex" class="flex-wrap">
          <form-item label="分类" prop="cateid" fill="2">
            <el-select v-loading="loading.newscateList" v-model="editData.cateid" filterable @change="handleCateChange">
              <template v-for="item in newscateList">
                <el-option v-if="item.issingle" :label="item.name" :value="item.id" :key="item.id" :disabled="item.outurl != null && item.outurl != ''">
                  {{ item.level === 1 ? '' : (space2 + '- ') }}{{ item.name }}
                </el-option>
              </template>
            </el-select>
          </form-item>
          <!-- <form-item label="选项">
            <el-switch v-model="editData.istop" active-text="置顶" />
          </form-item> -->
          <form-item label="标题" prop="title" fill="4" wrap>
            <el-input v-model="editData.title"></el-input>
          </form-item>
          <!-- <form-item label="副标题" prop="title2" fill="4" wrap>
            <el-input v-model="editData.title2"></el-input>
          </form-item> -->
          <!-- <form-item label="题图" fill="2">
            <el-upload
              class="avatar-uploader company-uploader"
              :headers="headers"
              :action="uploadPic"
              :show-file-list="false"
              :on-success="handleUploadSuccess"
              :before-upload="beforeUpload"
            >
              <img v-if="editData.pic" :src="rootPath + editData.pic" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <JyButton v-if="editData.pic" class="text-danger" is-a @click.stop="delPic">删除图片</JyButton>
            </el-upload>
          </form-item> -->
          <form-item label="浏览量" prop="hits" fill="4" wrap>
            <el-input type="number" v-model.number="editData.hits"></el-input>
          </form-item>
          <form-item label="发布时间" prop="createtime" fill="2">
            <el-date-picker
              v-model="editData.createtime"
              type="datetime"
              placeholder="选择发布时间">
            </el-date-picker>
          </form-item>
          <!--
          <form-item v-if="isSignup" label="价格" prop="price" fill="2" wrap>
            <el-input v-model.number="editData.price">
              <span slot="suffix">售价</span>
            </el-input>
          </form-item>
          <form-item v-if="isSignup" label="开始报名" prop="isup" fill="2" wrap>
            <el-radio-group v-model="editData.isup">
              <el-radio :label="true">立即开始</el-radio>
              <el-radio :label="false">稍后开始</el-radio>
            </el-radio-group>
          </form-item>
          <form-item v-if="isSignup" label="开始/截止" prop="uptime" fill="2">
            <div class="d-flex">
              <el-date-picker v-model="editData.uptime" type="datetime" :picker-options="pickerOptions0" value-format="yyyy-MM-dd HH:mm:ss" :disabled="editData.isup"></el-date-picker>
              <span> ~ </span>
              <el-date-picker v-model="editData.downtime" type="datetime" :picker-options="pickerOptions1" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </form-item>
          -->
          <!-- <form-item label="摘要" prop="summary" fill="4">
            <el-input type="textarea" v-model="editData.summary" :autosize="{maxRows:6}"></el-input>
          </form-item> -->
          <form-item label="内容" prop="content" fill="4">
            <JyEditor :content="editData.content" @blur="upateContent" :params="editData" :uploadHeaders="headers" :zIndex="1000"
              :uploadParams="{isEditor:'true'}" :uploadImgUrl="uploadPic" :imgOnLoad="editImgOnLoad" has-code />
          </form-item>
        </el-row>
      </el-form>
      <template v-slot:footer>
      <JyButton type="dark" is-outline icon="reply" @click="$router.go(-1)" class="mr-2">返回</JyButton>
      <JyButton type="success" icon="save" :isLoading="saveLoading" class="mr-2" @click="doSave()">{{ editData.id ? '确定更新' : '确定发布' }}</JyButton>
      <!-- <JyButton type="success" icon="save" :isLoading="saveLoading" @click="doSave()">保存内容</JyButton> -->
    </template>
  </TemplateEdit>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';
import TemplateEdit from '../template-edit.vue';
import tools from 'jyutils/tools';
import { parseDate } from 'element-ui/src/utils/date-util';
export default {
  components: { TemplateEdit },
  mixins: [tools],
  props: {
    id: String,
    cateid: String
  },
  data() {
    return {
      editTitle: '',
      editLoading: false,
      saveLoading: false,
      editImgs: [],
      rules: {
        cateid: {required:true, message:'请选择分类！'},
        title: {required:true, message:'标题必填！'},
        createtime: {required:true, message:'发布时间必填！'},
        uptime: {required:false, message:'请选择开始时间'},
        hits: {required:true, type:'integer', min:0, message:'请输入正整数！'},
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      newscateList: [types.BASE_LOAD.newscateList],
      loading: [types.BASE_LOAD.baseLoading]
    }),
    defaultData() {
      return {
        cateid:null, cateid2:null, cateid3:null, title:'', title1:null, title2:null, summary:'', content:'', createtime:new Date(),
        pic:null, istop:false, hits:0,
        issignup: false, isup: false, uptime:null, downtime: null, price: null
      }
    },
    isSignup() {
      return this.editData.issignup;
    },
    pickerOptions1() {
      let start = this.editData.uptime ? parseDate(this.editData.uptime, 'yyyy-MM-dd HH:mm:ss').getTime() : null;
      return  {
        disabledDate(time) {
          start = start || Date.now();
          return time.getTime() < start;
        }
      }
    },
  },
  watch: {
    id() {
      this.getData();
    },
    isSignup() {
      this.$refs.editForm.clearValidate();
    },
    'editData.isup'(val) {
      this.rules.uptime.required = !val;
      this.$nextTick(() => {
        this.$refs.editForm.validateField('uptime');
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.confirmSave(
      `未保存内容 [ ${this.editData.title || ''} ] ，确定要离开吗？`,
      next,
      () => {
        next(false);
      }
    );
  },
  methods: {
    getData() {
      this.editLoading = true;
      this.editData = {};
      if (this.id) {
        this.doGet({
          url: 'sys/news/getById/'+ this.id,
          okcb: (json) => {
            this.editData = Object.assign({}, this.editData, json);
            this.initEditData();
          },
          cb: () => {
            this.editLoading = false;
          }
        });
      } else {
        this.editData = Object.assign({}, this.defaultData, {cateid: this.cateid || null, createtime: this.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')});
        this.initEditData();
        this.editLoading = false;
      }
      if (!this.newscateList || !this.newscateList.length) {
        this.$store.dispatch(types.BASE_LOAD.newscateList);
      }
    },
    initEditData() {
      this.editTitle = (this.editData.id ? '编辑 - ' + this.editData.title : '添加内容');

      this.editImgs = [];

      // set origin data for check modified
      this.setOriaData();
    },
    handleCateChange(val) {
      let cates = this.newscateList.filter(d => d.id == val);

      if (cates.length) {
        this.editData.issignup = cates[0].issignup;
      }
    },
    handleUploadSuccess(res) {
      if (res.obj && res.obj.pic) {
        this.editData.pic = res.obj.pic;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    delPic() {
      this.msgbox('确定要删除题图吗？删除后保存生效！', () => {
        this.editData.pic = null;
        this.$refs.upload.clearFiles();
      });
    },
    editImgOnLoad(json, insertImg) {
      if (json && json.obj && json.obj.pic) {
        let src = json.obj.pic;
        this.editImgs.push(src);
        src = this.rootPath + src;
        insertImg(src);
      }
    },
    upateContent(html, obj) {
      obj.content = html;
    },
    doSave() {
      this.submitform().then(() => {
        let postData = {};
        this.saveLoading = true;
        Object.assign(postData, this.editData);
        postData.editImgs = this.editImgs;
        if (postData.createtime instanceof Date) {
          postData.createtime = this.formatDate(postData.createtime, 'yyyy-MM-dd HH:mm:ss');
        }
        if (!this.isSignup) {
          Object.assign(postData, {isup:false, uptime:null, downtime:null, code:null, sales:0, market:null, price:null});
        }

        postData.version === null ? postData.version = 1 : (postData.version += 1);
        this.doPost({
          url: 'sys/news/save',
          data: postData,
          okcb: () => {
            // 更新vuex
            this.$store.commit(types.OTHER.reloadNews);
            // 跳转
            this.setOriaData(0, () => {
              this.$message.success('保存成功！');
              this.$router.push({name:'news-single'});
            });
          },
          cb: () => {
            this.saveLoading = false;
          }
        });
      })
      .catch(() => {
        
      });
    }
  }
}
</script>

<style>
.company-uploader-icon {
    display: inline-block;
    font-size: 4rem;
    color: #8c939d;
    width: 260px;
    height: 68px;
    line-height: 68px;
    text-align: center;
}
.company-uploader .avatar{width:auto; height:68px;}
.company-uploader .jy-upload-preview{position:absolute; left:50%; top:50%; height:68px; transform:translate(-50%, -50%);}
</style>